import { render, staticRenderFns } from "./GuardarButton.vue?vue&type=template&id=f8856b0a&scoped=true&"
import script from "./GuardarButton.vue?vue&type=script&lang=ts&"
export * from "./GuardarButton.vue?vue&type=script&lang=ts&"
import style0 from "./GuardarButton.vue?vue&type=style&index=0&id=f8856b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8856b0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f8856b0a', component.options)
    } else {
      api.reload('f8856b0a', component.options)
    }
    module.hot.accept("./GuardarButton.vue?vue&type=template&id=f8856b0a&scoped=true&", function () {
      api.rerender('f8856b0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/GuardarButton.vue"
export default component.exports